import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";
import { petReservationSummaryKey } from "./usePetReservationSummary";

type PetReservationNotesInput = {
  petId: string;
  daycareHotelNotes?: string | null;
};

export function useUpdatePetReservationFields() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ petId, daycareHotelNotes }: PetReservationNotesInput) => {
      const update: Database["public"]["Tables"]["pets"]["Update"] = {
        daycare_hotel_notes: daycareHotelNotes ?? null,
      };
      const { error } = await supabase.from("pets").update(update).eq("id", petId);
      if (error) throw error;
    },
    onSuccess: (_, values) => {
      queryClient.invalidateQueries({ queryKey: petReservationSummaryKey(values.petId) });
    },
  });
}
